const EASE = [0.16, 1, 0.3, 1];

// Page-load reveal/entrance animations removed: content renders immediately
// in its final position. Kept as passthrough wrappers to avoid touching every call site.
export const Reveal = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

// Static line rendering (no masked slide-in). `lines` is an array of strings.
export const MaskedLines = ({ lines, className = "", lineClassName = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className={`block ${lineClassName}`}>
        {line}{" "}
      </span>
    ))}
  </span>
);

export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: EASE },
  }),
};
